import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import variables from "../../Context/Variables";
import skeleton from "./InformeVentas/Skeleton/InformeVentasSkeleton.module.scss";
import InformeVentas from "./InformeVentas/InformeVentas";
import styles from "./InformeVentas/InformeVentas.module.scss";
import NoPermissionPage from "../../Components/NoPermissionPage/NoPermissionPage";

const InformeVentasPage = () => {
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const navigate = useNavigate();
    const [datosInforme, setDatosInforme] = useState(null);
    const [rrpps, setRrpps] = useState([]);
    const [hasPermission, setHasPermission] = useState(true);
    const hasFetchedData = useRef(false);

    useEffect(() => {
        if (hasFetchedData.current) return;
        hasFetchedData.current = true;

        document.title = "Informe ventas";
        window.scrollTo(0, 0);
        ensureAuthenticated();

        const userDetails = sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails');
        const userData = JSON.parse(userDetails);
        const token = userData.jwt;

        if (!token) {
            navigate("/login");
        } else {
            fetchDatosInforme(token);
            fetchRrpps(token);
        }
    }, [id]);

    const fetchDatosInforme = (token) => {
        axios.get(`${variables.API_BASE_URL}/api/eventos/${id}/informe-ventas`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(response => {
            setDatosInforme(response.data);
            setLoading(false);
        }).catch(error => {
            console.error("Error al obtener los datos del informe:", error);
            setLoading(false);
            if (error.response && error.response.status === 401) {
                setHasPermission(false);
            }
        });
    };

    const fetchRrpps = (token) => {
        axios.get(`${variables.API_BASE_URL}/api/rrpps/${id}/reporteRrpps`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(response => {
            setRrpps(response.data);
            setLoading(false);
        }).catch(error => {
            console.error("Error al obtener los RRPPs:", error);
            setLoading(false);
            if (error.response && error.response.status === 401) {
                setHasPermission(false);
            }
        });
    };

    const ensureAuthenticated = () => {
        const userDetails = sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails');
        if (!userDetails) {
            navigate("/login");
        } else {
            const details = JSON.parse(userDetails);
            if (details.rol !== "PRODUCTOR") {
                setHasPermission(false);
            }
        }
    };

    if (!hasPermission) {
        return <NoPermissionPage />;
    }

    if (loading) {
        return (
            <div className={skeleton.cuerpo}>
                <div className={skeleton.titulo}></div>
                <div className={skeleton.lineaDivisora}></div>
                <div className={skeleton.tabla}>
                    <div className={`${skeleton.th} ${skeleton.brtop}`}></div>
                    <div className={skeleton.td}></div>
                    <div className={skeleton.td}></div>
                    <div className={`${skeleton.td} ${skeleton.brbottom}`}></div>
                </div>

                <div className={skeleton.tabla}>
                    <div className={`${skeleton.th} ${skeleton.brtop}`}></div>
                    <div className={skeleton.td}></div>
                    <div className={skeleton.td}></div>
                    <div className={skeleton.td}></div>
                    <div className={skeleton.td}></div>
                    <div className={skeleton.td}></div>
                    <div className={`${skeleton.td} ${skeleton.brbottom}`}></div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.bodyInforme}>
            {datosInforme && <InformeVentas datos={datosInforme} rrpps={rrpps} eventoId={id} />}
        </div>
    );
};

export default InformeVentasPage;